import { Backdrop, Badge } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Styles from './ImagePopup.module.scss';
import { useContext } from 'react';
import { ViewContext } from 'components/lib';

export const ImagePopup = ({ showInfo, hideImageInfo, imageSrc }) => {
    const viewContext = useContext(ViewContext);

    const handleImageClose = () => {
        hideImageInfo();
    };

    return (
        <Backdrop
            sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.drawer + 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
            open={showInfo}
        >
            <Badge
                aria-label={viewContext.t("Components.ImagePopup.label")}
                badgeContent={
                    <CloseIcon
                        className={Styles.closeBadge}
                        onClick={handleImageClose}
                        style={{
                            height: '40px',
                            width: '40px',
                        }}
                    />
                }
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <div id="imageInfoContainer" className={Styles.imageInfoCard}>
                    <div id="imageContainer" className={Styles.imageContainer}>
                        <img
                            id="imageViewer"
                            src={imageSrc}
                            alt={viewContext.t("Components.ImagePopup.altText")}
                            className={Styles.imageViewer}
                            onContextMenu={(e) => {
                                e.preventDefault();
                                return false;
                            }}
                        />
                    </div>
                </div>
            </Badge>
        </Backdrop>
    );
};